import ValidationBase, { ValidateUtil, ValidationType } from "./ValidationBase";

export class FieldAttachment {
    File: any;
    Id: string;
    HashName: string = "";
    IsLoading: boolean = false;
    ErrorMessage: string = "";

    constructor(File: any, Id: string) {
        this.File = File;
        this.Id = Id;
        this.HashName = `filehash_${new Date().getTime()}`;
    }
}

export default class FormFieldAttachmentBase {
    Values: FieldAttachment[];
    TypeEnum: any;
    Error: string;
    LimitedFiles: number;
    Validations: ValidationBase[];
    Mandatory: boolean;

    ValidateFieldCustom: (value: any, state?: any) => string;

    constructor(Values: any[], LimitedFiles: number, Validations: ValidationBase[], TypeEnum: any = null, callBackCustomValidation?: (Value: any, state?: any) => string) {
        this.Values = Values;
        this.Error = "";
        this.TypeEnum = TypeEnum;
        this.LimitedFiles = LimitedFiles;
        this.Validations = Validations;
        this.Mandatory = false;

        if (callBackCustomValidation)
            this.ValidateFieldCustom = callBackCustomValidation;
        else
            this.ValidateFieldCustom = () => "";

        if (this.Validations != null && this.Validations.length > 0) {
            for (let index = 0; index < this.Validations.length; index++) {
                const element = this.Validations[index];
                if (element.Validation === ValidationType.ANEXO_OBRIGATORIO) {
                    this.Mandatory = true;
                }
            }
        }
    }

    HasError(): boolean {

        if (this.Validations === null || this.Validations.length === 0) {
            return false;
        }

        return !(this.Error === "");
    }

    ValidateField(state?: any): string {
        if (this.Validations != null && this.Validations.length > 0) {
            for (let index = 0; index < this.Validations.length; index++) {
                const element = this.Validations[index];

                const errorMessage = ValidateUtil(element.Validation, this.Values, (value: any) => this.ValidateFieldCustom(value, state))

                if (errorMessage !== null && errorMessage !== "") {
                    if (element.Message !== "") {
                        this.Error = element.Message
                    } else {
                        this.Error = errorMessage;
                    }
                    break;
                } else {
                    this.Error = ""
                }
            }
        }

        return this.Error;
    }
}